/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Calendar_SubtitleInputs */

const cs_settings_calendar_subtitle = /** @type {(inputs: Settings_Calendar_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tohle je váš kalendář, ne kanceláře. Připojte Google nebo Microsoft, který používáte na prohlídky — osobní Gmail, firemní Workspace, Outlook.com i Microsoft 365. API klíč se sem nepíše.`)
};

const en_settings_calendar_subtitle = /** @type {(inputs: Settings_Calendar_SubtitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This is your calendar, not the office’s. Connect the Google or Microsoft account you use for viewings — personal Gmail, work Workspace, Outlook.com, or Microsoft 365. You do not paste an API key.`)
};

/**
* | output |
* | --- |
* | "This is your calendar, not the office’s. Connect the Google or Microsoft account you use for viewings — personal Gmail, work Workspace, Outlook.com, or Micro..." |
*
* @param {Settings_Calendar_SubtitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_calendar_subtitle = /** @type {((inputs?: Settings_Calendar_SubtitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Calendar_SubtitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_calendar_subtitle(inputs)
	return cs_settings_calendar_subtitle(inputs)
});